import { AlertCard } from '@apollo/space-kit/AlertCard';
import { motion } from 'framer-motion';
import React from 'react';

export const CustomToast = ({
  onClose,
  heading,
  description,
  theme = 'dark',
  type = 'success',
}: {
  onClose: () => void;
  heading: string;
  description: React.ReactNode;
  theme?: 'dark' | 'light';
  type?: 'success' | 'info' | 'warn' | 'error' | 'event';
}) => {
  return (
    <AlertCard
      dismissable
      theme={theme}
      as={
        <motion.section
          layout
          initial={{ opacity: 0, y: '20%' }}
          animate={{
            opacity: 1,
            y: 0,
            transition: {
              ease: [0.25, 1, 0.5, 1],
            },
          }}
          exit={{
            opacity: 0,
            y: '20%',
            transition: {
              ease: [0.5, 0, 0.75, 0],
            },
          }}
          transition={{
            duration: 0.2,

            type: 'tween',
          }}
        />
      }
      className="pointer-events-auto relative m-2 w-96 break-words"
      onClose={onClose}
      type={type}
      heading={heading}
    >
      {description}
    </AlertCard>
  );
};
